import { multiply, add, cross, dot, vectorFromPoints, isParallel } from "../../utils/vectorUtil"

import { arrowRightD, arrowLeftD, arrowUpD, arrowDownD } from "./arrowD"
import { getPortPosition } from "../../utils/dom"
import generateConnectionPoints from "../../utils/pathPoints/connection-straight"

let arrowMap = [
    { name: "right", direction: [1, 0], arrow: arrowRightD, delta: [0, 0] },
    { name: "left", direction: [-1, 0], arrow: arrowLeftD, delta: [12, 0] },
    { name: "up", direction: [0, -1], arrow: arrowUpD, delta: [10, 5] },
    { name: "down", direction: [0, 1], arrow: arrowDownD, delta: [10, -5] }
]

let extension = 20;
let radius = 5;

let middleCache = new Map();

let getRatio = function (points, id) {
    let ratio = 0.5
    let middlePoints;
    let middleP = points.find(v => v.type == 'pathMiddleP')
    if (middleP) {

        if (middleCache.has(id)) {
            //    ratio = middleCache.get(id).ratio;
            //    middlePath = middleCache.get(id).middlePath;
            middleCache.delete(id)
        }

        middlePoints = [points[2].position, middleP.position]

        for (let value of middleCache.values()) {
            let res = isOverlapping(value.middlePoints, middlePoints)

            if (res) {
                ratio =Math.max(ratio,value.ratio >= 0.8 ? 0.1 : value.ratio + 0.1) 
            }
        }

        middleCache.set(id, { ratio, middlePoints })

    }

    return ratio;
}
//判断两个线段是否平行且有部分重叠
const isOverlapping = function (pointsA, pointsB) {
    let vectorA = vectorFromPoints(...pointsA)
    let vectorB = vectorFromPoints(...pointsB)
    if (!isParallel(vectorA, vectorB)) return false;
   
    if(pointsA[0][0] != pointsB[0][0] && pointsA[0][1] != pointsB[0][1]) return false;
    let index = pointsA[0][0] == pointsA[1][0] ? 1 : 0; //取y值还是x值
    let betweenLine = (p0Index, p1Index) => ((value) => value > Math.min(p0Index, p1Index) && value < Math.max(p0Index, p1Index))

    let betweenLineA = betweenLine(pointsA[0][index], pointsA[1][index])
    let betweenLineB = betweenLine(pointsB[0][index], pointsB[1][index])

    let resultA = [pointsA[0][index], pointsA[1][index]].reduce((res, v) => betweenLineB(v) || res, false)

    if (resultA) return true;
    let resultB = [pointsB[0][index], pointsB[1][index]].reduce((res, v) => betweenLineA(v) || res, false)
    if (resultB) return true;
    return false;
}

// 判断是否平行
const isSameLine=function(pointsA, pointsB){
    let xMax = Math.max(pointsA[0][0],pointsA[1][0],pointsB[0][0] ,pointsB[1][0]);
    let xMin = Math.min(pointsA[0][0],pointsA[1][0],pointsB[0][0] ,pointsB[1][0]);
    if(xMax == xMin) return true;
    let yMax = Math.max(pointsA[0][1],pointsA[1][1],pointsB[0][1],pointsB[1][1]);
    let yMin = Math.min(pointsA[0][1],pointsA[1][1],pointsB[0][1],pointsB[1][1]);
    if(yMax == yMin) return true;
    return false;
}


function drawLine(el, linkData) {

    let param = {
        entryPoint: getPortPosition(linkData.source, el) || getPositionByTemp(linkData.source),
        entryDirection: linkData.source.port ? arrowMap.find(v => v.name == linkData.source.port).direction : [0, 0],
        entryExt: extension,
        exitPoint: getPortPosition(linkData.target, el) || getPositionByTemp(linkData.target),
        exitDirection: linkData.target.port ? arrowMap.find(v => v.name == linkData.target.port).direction : [0, 0],
        exitExt: extension,
    }
 
    //获取连接线的转折点  在最终连接或者拖曳时 

    let points;
    if (linkData.turnRatio && linkData.target.groupId && linkData.type == "link" ) {

        let newRatio = linkData.turnRatio;
        points = generateConnectionPoints(param, newRatio)
    } else if(linkData.type == "guide"){
        points = generateConnectionPoints(param)
    }else{
        points = generateConnectionPoints(param)

        let newRatio = getRatio(points, linkData.id)

        points = newRatio != 0.5 ? generateConnectionPoints(param, newRatio) : points;
        if(linkData.target.groupId) linkData.turnRatio = newRatio;
    }

    //连接线 的 d
    let d = getConnectionPath(points, radius);
    let lastDirection = points[points.length - 1].direction;
    let arrowD = arrowMap.find(v => v.direction.join() == lastDirection.join())
    let delta = arrowD.delta;
    let connectionG;
    if (connectionG = el.select(`[l-id='${linkData.id}']`)) {
        
        let connectionEdge = connectionG.select(".tflow-connection-edge");
        connectionEdge.attr({ d })
        let connection = connectionG.select(".tflow-connection");
        connection.attr({ d })
        
        
        let [x, y] = param.exitPoint;
        let arrow = connectionG.select(".arrow");
        arrow.attr({ d: arrowD.arrow, transform: `translate(${x - 10 + delta[0]},${y + delta[1]})`, stroke: "#61B7CF", fill: "#61B7CF", "n-id": linkData.id })

    } else {
        let connectionEdge = el.path(d).attr({ stroke: "#fff",  fill: "none" ,pointerEvents:"visiblestroke"}).addClass("tflow-connection-edge")
        connectionEdge.mouseover(function(){
            this.parent().addClass("tflow-connection-hover")
        }).mouseout(function(){
            this.parent().removeClass("tflow-connection-hover")
        })
        let connection = el.path(d).attr({ stroke: "#61B7CF",  fill: "none" ,pointerEvents:"none"}).addClass("tflow-connection")
        
        let [x, y] = param.exitPoint;
        let arrow = el.path(arrowD.arrow || "")
            .attr({ transform: `translate(${x - 10 + delta[0]},${y + delta[1]})`, stroke: "#61B7CF", fill: "#61B7CF", "n-id": linkData.id })
            .addClass("arrow");
        connectionG = el.group(connectionEdge,connection,arrow).attr({ "l-id": linkData.id })
    }
    return connectionG;
}
function getConnectionPath(points, radius) {


    let length = points.length;
    if (length < 1) return;
    let result = points.reduce((a, b) => {
        // console.log(a,b);
        let [x, y] = add(b.position, multiply(b.direction, -1 * radius))
        if (!a.d) {
            let positionA = a.position;
            b.d = `M${positionA[0]} ${positionA[1]} L ${x} ${y}`;
            return b

        }

        let d = a.d;
        // 是否同向 同向则不画圆角
        let isSameDirection = dot(a.direction, b.direction) == 1 ? true : false;
        if (isSameDirection) {
            d += `L ${x} ${y}`
            b.d = d
            return b
        }


        let startPosition = a.position;
        let [x0, y0] = add(startPosition, multiply(b.direction, radius))
        // 叉乘判断圆角顺时针还是逆时针
        let clockwise = cross(a.direction, b.direction) > 0 ? 1 : 0;

        d += `A${radius} ${radius} 0 0,${clockwise} ${x0} ${y0} L ${x} ${y}`
        b.d = d
        return b
    })
    return result.d;

}

function getPositionByTemp(joint) {
    return joint.position;
}

function init(ctx){
    let config = ctx.config;
    if(config && config.connectionConfig){
        radius = config.connectionConfig.radius || radius;
        extension = config.connectionConfig.extension || extension
    }
}
export default { drawLine,init };


// WEBPACK FOOTER //
// ./src/assets/tflow/render/connection/straightConnections.js